import { render, staticRenderFns } from "./InternationalFederations.vue?vue&type=template&id=51e5f538&"
import script from "./InternationalFederations.vue?vue&type=script&lang=js&"
export * from "./InternationalFederations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports